import DeputiesTable from './DeputiesTable';

export default DeputiesTable;
